import { ColumnMetadata } from "@valg-shared/components/table/table/column-metadata";
import { WithPropsOfType } from "@valg-shared/forms";
import { ElectoralCoalitionDto } from "@shared/clients/api.generated";
import { sortByDanishLanguageRules } from "utils/sort-utils";


export const ElectoralCoalitionColumnDef: WithPropsOfType<ElectoralCoalitionDto, ColumnMetadata> = {
  listLettersOrName: {
    title: 'electoral_coalition.table_header',
    sortable: true,
    defaultSort: 'asc',
    sortFunction: sortByDanishLanguageRules,
  },
  id: { title: 'id', disable: true }
};
